import { useEffect, useRef, useState } from 'react';
import CustomBlockButton from '../../../../components/button/CustomBlockButton';
import { CustomRatioImage } from '../../../../components/image/CustomRatioImage';
import * as St from './weget-navbar.styled';
import { CustomDialog } from '../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../components/input/CustomLabelInput';
import { useApiInfoContextActionsHook, useApiInfoContextValueHook } from '../../../../contexts/ApiInfoContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQueryParamsHook } from '../../../../hooks/useQueryParamsHook';

const TAB_LIST = [
    {
        pathname: '/',
        name: '홈'
    },
    {
        pathname: '/inbound/register',
        name: '입고리스트 등록'
    },
    {
        pathname: '/inbound/in-progress',
        name: '입고 진행중'
    },
    {
        pathname: '/inbound/pallet-info',
        name: '파레트 정보'
    },
    // {
    //     pathname: '/inbound/scan-completed',
    //     name: '스캔 완료'
    // },
    // {
    //     pathname: '/inbound/completed',
    //     name: '입고 완료'
    // },
    // {
    //     pathname: '/inbound/palette',
    //     name: '입고 파레트 계산'
    // },
    {
        pathname: '/inbound/rack-location',
        name: '로케이션'
    },
    {
        pathname: '/inbound/stage',
        name: '스테이지'
    },
]

export function WegetNavbar(props) {
    const navigate = useNavigate();
    const queryParamsHook = useQueryParamsHook();
    const location = useLocation();
    const currentPagePath = location?.pathname;

    const tabRefs = useRef({}); // 각 버튼의 참조를 저장할 객체

    const [apiSettingModalOpen, setApiSettingModalOpen] = useState(false);

    useEffect(() => {
        // currentPagePath에 해당하는 버튼의 참조가 있을 경우
        if (tabRefs.current[currentPagePath]) {
            const tabElement = tabRefs.current[currentPagePath];
            tabElement.scrollIntoView({ behavior: 'auto', inline: 'center' });
        }
    }, [currentPagePath]);

    const handleChangeRoute = (path) => {
        const queryParams = queryParamsHook.params;
        const queryString = new URLSearchParams(queryParams).toString();
        const fullPath = `${path}?${queryString}`;

        navigate(fullPath, { replace: true });
    }

    const toggleApiSettingModalOpen = (bool) => {
        setApiSettingModalOpen(bool);
    }

    return (
        <>
            <St.MainNav.Container>
                <St.MainNav.Title>입고프로세스</St.MainNav.Title>
                <St.MainNav.Setting>
                    <CustomBlockButton
                        type='button'
                        onClick={() => toggleApiSettingModalOpen(true)}
                    >
                        API 설정
                    </CustomBlockButton>
                </St.MainNav.Setting>
            </St.MainNav.Container>
            <St.SubNav.Container>
                <St.SubNav.TabList>
                    {TAB_LIST?.map(tab => {
                        return (
                            <CustomBlockButton
                                key={tab.pathname}
                                type='button'
                                className={currentPagePath === tab.pathname ? 'active' : ''}
                                onClick={() => handleChangeRoute(tab.pathname)}
                                ref={el => (tabRefs.current[tab.pathname] = el)} // 버튼 참조 저장
                            >
                                {tab.name}
                            </CustomBlockButton>
                        );
                    })}
                </St.SubNav.TabList>
            </St.SubNav.Container>

            {apiSettingModalOpen &&
                <ApiSettingModal
                    open={apiSettingModalOpen}
                    toggleOpenClose={toggleApiSettingModalOpen}
                />
            }
        </>
    );
}

const ApiSettingModal = ({
    open,
    toggleOpenClose
}) => {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const apiInfoContextActionsHook = useApiInfoContextActionsHook();

    const [apiKey, setApiKey] = useState(apiInfoContextValueHook?.apiInfo?.apiKey);
    const [secretKey, setSecretKey] = useState(apiInfoContextValueHook?.apiInfo?.secretKey);

    const handleChangeApiKey = (e) => {
        const value = e.target.value;

        setApiKey(value);
    }

    const handleChangeSecretKey = (e) => {
        const value = e.target.value;

        setSecretKey(value);
    }

    const handleSaveApiInfo = (e) => {
        e.preventDefault();
        apiInfoContextActionsHook.onSet(apiKey, secretKey);
        toggleOpenClose(false);
    }

    return (
        <CustomDialog open={open} onClose={() => toggleOpenClose(false)}>
            <St.ApiSettingModal.Container>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>API 설정</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => toggleOpenClose(false)} />
                </CustomDialog.Header>
                <form onSubmit={(e) => handleSaveApiInfo(e)}>
                    <St.ApiSettingModal.Body>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={apiKey || ''}
                                onChange={(e) => handleChangeApiKey(e)}
                            />
                            <CustomLabelInput.Label>API Key</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='password'
                                value={secretKey || ''}
                                onChange={(e) => handleChangeSecretKey(e)}
                            />
                            <CustomLabelInput.Label>Secret Key</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomBlockButton
                            type='submit'
                        >
                            등록
                        </CustomBlockButton>
                    </St.ApiSettingModal.Body>
                </form>
            </St.ApiSettingModal.Container>
        </CustomDialog>
    )
}